import {Stack} from 'shells/layout/stack/stack';

import {ExplorePageSectionHeader} from '../explore-page-section-header';

import {getActiveOffers} from './offers-config';
import {OffersGrid} from './offers-grid';

export function UpcomingOffersSection() {
    // Currently no offers are active, and the only webcast shown was the Nutshell 101, which has been moved
    // up to a higher section in a different component, so currently this section does not show.
    // However it will once offers are added
    if (!getActiveOffers().length) return null;

    return (
        <Stack spacing={16}>
            <ExplorePageSectionHeader title='Upcoming events & offers' />
            <OffersGrid />
        </Stack>
    );
}
